import gsap from "gsap";
export const hoverBoton = (e) => {
    gsap.to(e.currentTarget, {
        scale: 1.05,
        y: -10,
        duration: 0.3,
        ease: "power2.out"
    });
};

export const salidaBoton = (e) => {
    gsap.to(e.currentTarget, {
        scale: 1,
        y: 0,
        duration: 0.3,
        ease: "power2.out"
    });
};

export const focusBoton = (bgcolor, txtcolor) => (e) => {
    gsap.killTweensOf(e.currentTarget);
    gsap.to(e.currentTarget, {
        backgroundColor: bgcolor,
        color: txtcolor,
        duration: 0.4,
        ease: "power2.out",
    });
};

export const blurBoton = (bgcolor, txtcolor) => (e) => {
    gsap.killTweensOf(e.currentTarget);
    gsap.to(e.currentTarget, {
        backgroundColor: bgcolor,
        color: txtcolor,
        duration: 0.4,
        ease: "power2.out",
    });
};

export const animarContenido = (ref, onComplete) => {
    gsap.to(ref, {
        opacity: 0,
        x: -40,
        duration: 0.25,
        ease: "power2.in",
        onComplete: () => {
            onComplete(() => {
                gsap.fromTo(
                    ref,
                    { opacity: 0, x: 40 },
                    { opacity: 1, x: 0, duration: 0.35, ease: "power2.out" }
                );
            });
        }
    });
};